module.exports = __webpack_public_path__ + "static/media/Lock.696b2a8b.svg";